
export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
              <i className="ri-heart-pulse-line text-white text-xl"></i>
            </div>
            <h1
              className="text-2xl font-bold text-emerald-600"
              style={{ fontFamily: "Allura, cursive" }}
            >
              Psicóloga Cláudia Vianna
            </h1>
          </div>
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#inicio" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
              Início
            </a>
            <a href="/blog" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
              Blog
            </a>
            <a href="#sobre" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
              Sobre
            </a>
            <a href="#servicos" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
              Serviços
            </a>
            <a href="#depoimentos" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
              Depoimentos
            </a>
            <a href="#contato" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
              Contato
            </a>
          </nav>
          <button className="md:hidden text-gray-700 cursor-pointer">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <section
        id="inicio"
        className="min-h-screen flex items-center justify-center relative bg-cover bg-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/54622bc5c89bb40bbbdc0eac8d2335b2/6b651c54223b614163cb324e5a90bef0.jpeg')",
        }}
      >
        <div className="container mx-auto px-4 text-center text-white w-full">
          <h2 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Saúde Mental com<br />
            <span className="text-emerald-400">Carinho e Profissionalismo</span>
          </h2>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Um espaço seguro e acolhedor para você cuidar da sua saúde mental com todo o suporte profissional que merece
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/5521999351239?text=Ol%C3%A1!%20Gostaria%20de%20agendar%20uma%20consulta%20com%20a%20Psic%C3%B3loga%20Cl%C3%A1udia%20Vianna."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-emerald-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Agendar Consulta
            </a>
            <a
              href="/blog"
              className="border-2 border-emerald-600 text-emerald-600 px-8 py-3 rounded-full font-semibold hover:bg-emerald-600 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              Saiba Mais
            </a>
          </div>
        </div>
      </section>

      {/* Como posso te ajudar */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-800 mb-4">Como posso te ajudar</h3>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Ofereço diferentes olhares para atender suas necessidades específicas
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-emerald-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-4">Atendimento Individual</h4>
              <p className="text-gray-600">
                Sessões personalizadas focadas nas suas necessidades específicas, oferecendo um espaço seguro
                para autoconhecimento e crescimento pessoal.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-group-line text-emerald-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-4">Terapia Online</h4>
              <p className="text-gray-600">
                Atendimento psicológico online com a mesma qualidade do presencial, oferecendo flexibilidade e
                comodidade para seu bem-estar.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-brain-line text-emerald-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-4">Avaliação Psicológica</h4>
              <p className="text-gray-600">
                Avaliações completas e detalhadas para compreender melhor aspectos cognitivos, emocionais e
                comportamentais.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Sobre */}
      <section id="sobre" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-4xl font-bold text-gray-800 mb-6">
                Conheça a <span className="text-emerald-600">Psicóloga Cláudia Vianna</span>
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Com 16 anos de experiência, minha missão é ajudar adolescentes e adultos a superar desafios
                emocionais e comportamentais, promovendo autoconhecimento e bem-estar. Minha formação em
                Psicologia, Letras e Orientação Pedagógica me permite compreender as complexidades de cada
                indivíduo, integrando diferentes perspectivas para oferecer um tratamento acolhedor, profundo e
                personalizado.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Acredito no poder da escuta atenta, do respeito e da empatia para criar um ambiente seguro
                e acolhedor. O meu objetivo é ajudá-lo a se conectar com os seus próprios sentimentos, pensamentos
                e comportamentos, desbloqueando o caminho para a cura e o crescimento pessoal.
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-emerald-600 text-sm"></i>
                  </div>
                  <span className="text-gray-700">CRP 05/78448</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-emerald-600 text-sm"></i>
                  </div>
                  <span className="text-gray-700">Especialização Psicanalítica</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-emerald-600 text-sm"></i>
                  </div>
                  <span className="text-gray-700">+ 16 anos de experiência</span>
                </div>
              </div>
              <a
                href="https://wa.me/5521999351239?text=Ol%C3%A1!%20Gostaria%20de%20agendar%20uma%20consulta%20com%20a%20Psic%C3%B3loga%20Cl%C3%A1udia%20Vianna."
                target="_blank"
                rel="noopener noreferrer"
                className="bg-emerald-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Agendar Consulta
              </a>
            </div>
            <div className="lg:order-last">
              <div className="relative">
                <img
                  alt="Psicóloga Cláudia Vianna"
                  className="w-full rounded-2xl shadow-2xl object-cover object-top"
                  src="https://static.readdy.ai/image/54622bc5c89bb40bbbdc0eac8d2335b2/9c96cd3eb18557e93be9e2ea9f4f1ede.jpeg"
                />
                <div className="absolute -bottom-6 -right-6 bg-emerald-600 text-white p-6 rounded-2xl shadow-lg">
                  <div className="text-center">
                    <div className="text-2xl font-bold">CRP</div>
                    <div className="text-sm">05/78448</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vídeo Apresentação */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-4xl font-bold text-gray-800 mb-4">Conheça Minha Abordagem Terapêutica</h3>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Assista ao vídeo e entenda como a psicoterapia pode transformar sua vida
            </p>
          </div>
          <div className="max-w-4xl mx-auto">
            <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden">
              <div className="aspect-video">
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/WBkJG7AGhIQ"
                  title="Apresentação da Terapia - Psicóloga Cláudia Vianna"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-8 text-center">
                <h4 className="text-2xl font-bold text-gray-800 mb-4">Entenda Como a Terapia Pode Te Ajudar</h4>
                <p className="text-gray-600 mb-6">
                  Neste vídeo, explico minha abordagem terapêutica e como podemos trabalhar juntos para promover seu
                  bem-estar emocional e crescimento pessoal.
                </p>
                <a
                  href="https://wa.me/5521999351239?text=Ol%C3%A1!%20Gostaria%20de%20agendar%20uma%20consulta%20com%20a%20Psic%C3%B3loga%20Cl%C3%A1udia%20Vianna."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-emerald-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Agendar Minha Consulta
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Saúde Mental - Vídeos Educativos */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-800 mb-4">Entendendo a Saúde Mental</h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Conheça mais sobre questões importantes da saúde mental através de vídeos educativos que podem esclarecer
              suas dúvidas
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {/* Vídeo Depressão */}
            <div className="bg-gray-50 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-video">
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/peZDkp6hx1s"
                  title="Entendendo a Depressão - Psicóloga Cláudia Vianna"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-heart-pulse-line text-blue-600 text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-800">Depressão</h4>
                </div>
                <p className="text-gray-600 mb-4">
                  Compreenda os sinais, sintomas e como a terapia pode ajudar no tratamento da depressão. Saiba quando
                  buscar ajuda profissional.
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Sintomas</span>
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Tratamento</span>
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">Apoio</span>
                </div>
              </div>
            </div>

            {/* Vídeo TDAH */}
            <div className="bg-gray-50 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-video">
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/oBx7WBU1YKU"
                  title="TDAH - Transtorno do Déficit de Atenção - Psicóloga Cláudia Vianna"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-brain-line text-orange-600 text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-800">TDAH</h4>
                </div>
                <p className="text-gray-600 mb-4">
                  Entenda o Transtorno do Déficit de Atenção e Hiperatividade, seus impactos na vida diária e as
                  estratégias terapêuticas disponíveis.
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm">Atenção</span>
                  <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm">Hiperatividade</span>
                  <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm">Estratégias</span>
                </div>
              </div>
            </div>

            {/* Vídeo Ansiedade */}
            <div className="bg-gray-50 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-video">
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/MOoS94a4sJw"
                  title="Ansiedade - Como Identificar e Tratar - Psicóloga Cláudia Vianna"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-mind-map text-green-600 text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-800 mb-4">Ansiedade</h4>
                </div>
                <p className="text-gray-600 mb-4">
                  Aprenda a identificar os sinais da ansiedade e descubra técnicas eficazes para gerenciar e reduzir os
                  sintomas no dia a dia.
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">Controle</span>
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">Técnicas</span>
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">Bem-estar</span>
                </div>
              </div>
            </div>
          </div>

          {/* Informações Adicionais */}
          <div className="mt-16 bg-emerald-50 rounded-2xl p-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-information-line text-emerald-600 text-2xl"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-800 mb-4">Precisa de Mais Informações?</h4>
              <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                Estes vídeos são apenas informativos e não substituem uma consulta profissional. Se você se identificou com
                algum dos temas abordados, agende uma consulta para uma avaliação personalizada.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://wa.me/5521999351239?text=Ol%C3%A1!%20Gostaria%20de%20agendar%20uma%20consulta%20com%20a%20Psic%C3%B3loga%20Cl%C3%A1udia%20Vianna."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-emerald-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Agendar Consulta
                </a>
                <a
                  href="/blog"
                  className="border-2 border-emerald-600 text-emerald-600 px-8 py-3 rounded-full font-semibold hover:bg-emerald-600 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  Saiba Mais
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Serviços Especializados */}
      <section id="servicos" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-800 mb-4">Serviços Especializados</h3>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Ofereço uma ampla gama de serviços psicológicos para atender diferentes necessidades
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-user-heart-line text-blue-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-4">Psicoterapia Individual</h4>
              <p className="text-gray-600 mb-4">
                Atendimento personalizado para questões como ansiedade, depressão, autoestima e desenvolvimento pessoal.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Terapia Psicanalítica</li>
                <li>• Gestão de ansiedade e estresse</li>
                <li>• Desenvolvimento da autoestima</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-team-line text-purple-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-4">Terapia de Adolescentes</h4>
              <p className="text-gray-600 mb-4">
                Apoio especializado para adolescentes enfrentando desafios emocionais, sociais e de desenvolvimento.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Questões de identidade</li>
                <li>• Problemas escolares</li>
                <li>• Relacionamentos familiares</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-2-line text-pink-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-4">Terapia para Casais</h4>
              <p className="text-gray-600 mb-4">
                Fortalecimento de relacionamentos através de comunicação efetiva e resolução de conflitos.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Melhoria da comunicação</li>
                <li>• Resolução de conflitos</li>
                <li>• Fortalecimento do vínculo</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-brain-line text-green-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-4">Avaliação Psicológica</h4>
              <p className="text-gray-600 mb-4">
                Avaliações detalhadas para compreender aspectos cognitivos, emocionais e comportamentais.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Avaliação neuropsicológica</li>
                <li>• Testes de personalidade</li>
                <li>• Relatórios especializados</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-computer-line text-orange-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-4">Terapia Online</h4>
              <p className="text-gray-600 mb-4">
                Atendimento psicológico à distância com a mesma qualidade do presencial, oferecendo flexibilidade.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Flexibilidade de horários</li>
                <li>• Conforto do seu lar</li>
                <li>• Mesma eficácia terapêutica</li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-group-line text-indigo-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-4">Orientação Familiar</h4>
              <p className="text-gray-600 mb-4">
                Apoio para famílias enfrentando desafios relacionais e de comunicação entre seus membros.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>• Mediação familiar</li>
                <li>• Comunicação eficaz</li>
                <li>• Resolução de conflitos</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Depoimentos */}
      <section id="depoimentos" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-800 mb-4">O que meus pacientes dizem</h3>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Veja os depoimentos de pessoas que transformaram suas vidas através da psicoterapia
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Depoimento 1 - Léo Borges */}
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
              </div>
              <p className="text-gray-600 mb-6 italic">
                "Excelente psicóloga! Recomendo!"
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-emerald-600 font-bold">L</span>
                </div>
                <div>
                  <div className="font-semibold text-gray-800">Léo Borges</div>
                  <div className="text-sm text-gray-500">7 meses atrás</div>
                </div>
              </div>
            </div>

            {/* Depoimento 2 - Rafael Penela */}
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
              </div>
              <p className="text-gray-600 mb-6 italic">
                "Profissional excelente! A Dra. Cláudia Vianna é atenciosa, acolhedora e extremamente competente. Suas orientações nos ajudaram muito durante um período difícil."
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-emerald-600 font-bold">R</span>
                </div>
                <div>
                  <div className="font-semibold text-gray-800">Rafael Penela</div>
                  <div className="text-sm text-gray-500">7 meses atrás</div>
                </div>
              </div>
            </div>

            {/* Depoimento 3 - Moezia Silva */}
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
              </div>
              <p className="text-gray-600 mb-6 italic">
                "O atendimento excelente, ajudou bastante. Eu recomendo com toda confiança."
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-emerald-600 font-bold">M</span>
                </div>
                <div>
                  <div className="font-semibold text-gray-800">Moezia Silva</div>
                  <div className="text-sm text-gray-500">5 meses atrás</div>
                </div>
              </div>
            </div>

            {/* Depoimento 4 - Maria Luiza Vianna */}
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
              </div>
              <p className="text-gray-600 mb-6 italic">
                "Excelente profissional! Trabalho impecável, com dedicação e profissionalismo! Super indico!"
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-emerald-600 font-bold">M</span>
                </div>
                <div>
                  <div className="font-semibold text-gray-800">Maria Luiza Vianna</div>
                  <div className="text-sm text-gray-500">7 meses atrás</div>
                </div>
              </div>
            </div>

            {/* Depoimento 5 - Paula Santos */}
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
              </div>
              <p className="text-gray-600 mb-6 italic">
                "Uma profissional maravilhosa, atenciosa."
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-emerald-600 font-bold">P</span>
                </div>
                <div>
                  <div className="font-semibold text-gray-800">Paula Santos</div>
                  <div className="text-sm text-gray-500">4 months ago</div>
                </div>
              </div>
            </div>

            {/* Depoimento 6 - Bianca Bia */}
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
              </div>
              <p className="text-gray-600 mb-6 italic">
                "Excelente profissional!!! Super indico!"
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-emerald-600 font-bold">B</span>
                </div>
                <div>
                  <div className="font-semibold text-gray-800">Bianca Bia</div>
                  <div className="text-sm text-gray-500">5 months ago</div>
                </div>
              </div>
            </div>

            {/* Depoimento 7 - Ana Costa */}
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
              </div>
              <p className="text-gray-600 mb-6 italic">
                "A terapia online foi uma experiência incrível. Mesmo à distância, senti todo o acolhimento e
                profissionalismo da Dra. Claudia."
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-emerald-600 font-bold">A</span>
                </div>
                <div>
                  <div className="font-semibold text-gray-800">Ana Costa</div>
                  <div className="text-sm text-gray-500">Paciente da terapia online</div>
                </div>
              </div>
            </div>

            {/* Depoimento 8 - Mariana Silva */}
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
              </div>
              <p className="text-gray-600 mb-6 italic">
                "Acompanhamento excepcional, com foco nas minhas necessidades e muito respeito ao meu ritmo. A Dra. Cláudia tem uma abordagem muito humana e profissional."
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-emerald-600 font-bold">M</span>
                </div>
                <div>
                  <div className="font-semibold text-gray-800">Mariana Silva</div>
                  <div className="text-sm text-gray-500">Paciente há 1 ano</div>
                </div>
              </div>
            </div>

            {/* Depoimento 9 - João Santos */}
            <div className="bg-gray-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
                <i className="ri-star-fill text-yellow-400 text-lg"></i>
              </div>
              <p className="text-gray-600 mb-6 italic">
                "Excelente profissional! Me sinto muito mais confiante e preparado para enfrentar os desafios da vida após as sessões com a Dra. Claudia."
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-emerald-600 font-bold">J</span>
                </div>
                <div>
                  <div className="font-semibold text-gray-800">João Santos</div>
                  <div className="text-sm text-gray-500">Paciente há 2 anos</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contato */}
      <section id="contato" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h3 className="text-4xl font-bold text-gray-800 mb-4">Entre em Contato</h3>
          <p className="text-lg text-gray-600 mb-8">
            Para mais informações ou agendar uma consulta, clique no botão abaixo.
          </p>
          <a
            href="https://wa.me/5521999351239?text=Ol%C3%A1!%20Gostaria%20de%20falar%20com%20a%20Psic%C3%B3loga%20Cl%C3%A1udia%20Vianna."
            target="_blank"
            rel="noopener noreferrer"
            className="bg-emerald-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Falar via WhatsApp
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-12">
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-white text-xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-emerald-400">Psicóloga Cláudia Vianna</h4>
              </div>
              <p className="text-gray-300 mb-6">
                Atendimento psicológico com carinho, respeito e profissionalismo para promover seu bem-estar emocional.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://instagram.com/psi.claudiavianna"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-white"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors cursor-pointer">
                  <i className="ri-facebook-line text-white"></i>
                </a>
               <a
                  href="https://www.youtube.com/@PsicólogaCláudiaVianna"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors cursor-pointer"
                >
                   <i className="ri-youtube-fill text-white"></i>
                </a>
              </div>
            </div>
            <div>
              <h5 className="text-lg font-semibold mb-6">Links Rápidos</h5>
              <ul className="space-y-3">
                <li><a href="#inicio" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">Início</a></li>
                <li><a href="#sobre" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">Sobre</a></li>
                <li><a href="#servicos" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">Serviços</a></li>
                <li><a href="/blog" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">Blog</a></li>
                <li><a href="#contato" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">Contato</a></li>
              </ul>
            </div>
            <div>
              <h5 className="text-lg font-semibold mb-6">Informações de Contato</h5>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-emerald-400 mr-3 mt-1"></i>
                <div className="text-gray-300">
                  <p>Avenida Benvindo de Novaes, 1900 -Recreio dos Bandeirantes, Rio de Janeiro – RJ, 22790‑382</p>
                  <p>Sala 204</p>
                </div>
              </div>
                <div className="flex items-center">
                  <i className="ri-whatsapp-line text-emerald-400 mr-3"></i>
                  <span className="text-gray-300">(21) 99935-1239</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-emerald-400 mr-3"></i>
                  <span className="text-gray-300">psiclaudiavianna@gmail.com</span>
                </div>
              </div>
            </div>
          </div>         
          <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
            <p>&copy; {new Date().getFullYear()} Psicóloga Cláudia Vianna. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}